'use strict';

import { fetchJson } from '../utils/fetchJson';

/**
 * Achievements
 */
class Achievements {
  /**
   * Constructor of Achievements.
   * @param {Object} options
   * @param {Object} player
   * @return {*}
   */
  constructor(options, player) {
    this._options = options;
    this._player = player;
  }

  async getAchievementDescription(code) {
    return new Promise((resolve, reject) => {
      const headers = new Headers();
      headers.append('Game-Key', this._options.gameId);
      let url = `${this._options.apiDomain}/achievement/${code}`;
      fetchJson(url, {
        method: 'GET',
        headers: headers,
      })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  }

  async claimAchievement(code) {
    return new Promise((resolve, reject) => {
      const headers = new Headers();
      headers.append('Game-Key', this._options.gameId);
      headers.append('Player-Token', this._player.token);
      let url = `${this._options.apiDomain}/achievement/${code}/claim`;
      fetchJson(url, {
        method: 'POST',
        headers: headers,
      })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  }

  async getAchievementEntries() {
    return new Promise((resolve, reject) => {
      const headers = new Headers();
      headers.append('Game-Key', this._options.gameId);
      headers.append('Player-Token', this._player.token);
      let url = `${this._options.apiDomain}/achievement`;
      fetchJson(url, {
        method: 'GET',
        headers: headers,
      })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  }
}
export default Achievements;
